<table class="water-stats">
  <thead>
    <tr>
      <th>
        <p>ספיקה ב- 20psi</p>
        <strong>Gpm</strong>
      </th>
      <th>
        <p>ספיקה ב- 0psi</p>
        <strong>Gpm</strong>
      </th>
      <th>
        <p>ספיקה נמדדת</p>
        <strong>Gpm</strong>
      </th>
      <th>
        <p>ספיקה נמדדת</p>
        <strong>Lpm</strong>
      </th>
      <th>
        <p>ספיקה נמדדת</p>
        <strong>M^3/h</strong>
      </th>
      <th>
        <p>לחץ שיורי</p>
        <strong>Psi</strong>
      </th>
      <th>
        <p>לחץ סטטי</p>
        <strong>Psi</strong>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>{{ waterSupplyData.expectedFlowAt_20psi || '--' }}</td>
      <td>{{ waterSupplyData.expectedFlowAt_0psi || '--' }}</td>
      <td>{{ totalFlow || '--' }}</td>
      <td>{{ toFixed(totalFlow * 3.785) || '--' }}</td>
      <td>{{ toFixed(totalFlow / 4.4) || '--' }}</td>
      <td>{{ residualPressure || '--' }}</td>
      <td>{{ staticPressure || '--' }}</td>
    </tr>
    <tr>
      <td colspan="7">
        <div echarts [options]="chartOption" class="chart" dir="ltr"></div>
      </td>
    </tr>
  </tbody>
</table>
